import { createFileRoute } from '@tanstack/react-router'
import { Prose } from '@/components/Prose'
import { MedicalDisclaimer } from '@/components/MedicalDisclaimer'

export const Route = createFileRoute('/_layout/terms')({
  component: TermsPage,
})

function TermsPage() {
  return (
    <section className="mx-auto max-w-3xl px-4 py-16">
      <Prose>
        <h1 className="text-text-primary">Terms of Service</h1>
        <p className="text-sm text-text-muted">Last updated: August 2026</p>

        <MedicalDisclaimer className="my-6" />

        <h2 className="text-text-primary">1. Educational use only</h2>
        <p>
          Lunara is provided for personal awareness, journaling, and educational purposes only. It is{' '}
          <strong>not a medical device</strong>, <strong>not a contraceptive</strong>, and{' '}
          <strong>not a substitute for professional medical advice</strong>. Cycle and ovulation
          predictions are approximate estimates based on the calendar method and may be inaccurate.
          Always consult a qualified healthcare provider for health decisions.
        </p>

        <h2 className="text-text-primary">2. Acceptance of terms</h2>
        <p>
          By using Lunara, you agree to these terms. If you do not agree, do not use the service.
        </p>

        <h2 className="text-text-primary">3. Your account and your data</h2>
        <p>
          You are responsible for keeping your password and recovery code secure. Because sync is
          end-to-end encrypted, we cannot recover your data if you lose both your password and your
          recovery code, and we cannot reset them on your behalf.
        </p>

        <h2 className="text-text-primary">4. No warranty</h2>
        <p>
          Lunara is provided &ldquo;as is&rdquo; and &ldquo;as available,&rdquo; without warranties
          of any kind. We do not guarantee that predictions are accurate, that the service will be
          uninterrupted or error-free, or that it will meet your health needs.
        </p>

        <h2 className="text-text-primary">5. Limitation of liability</h2>
        <p>
          To the maximum extent permitted by law, Lunara and its operators are not liable for any
          direct, indirect, incidental, or consequential damages arising from your use of, or
          reliance on, the service — including any reliance on predictions for conception,
          contraception, or health decisions.
        </p>

        <h2 className="text-text-primary">6. Acceptable use</h2>
        <p>
          You agree not to misuse the service, attempt to access data you are not authorized to
          access, or disrupt the service. We may suspend accounts that violate these terms.
        </p>

        <h2 className="text-text-primary">7. Third-party links</h2>
        <p>
          Content pages may link to third-party sites and may include affiliate links (clearly
          disclosed). We are not responsible for the practices or content of third parties.
        </p>

        <h2 className="text-text-primary">8. Changes</h2>
        <p>
          We may update these terms. Continued use after changes constitutes acceptance. For
          questions, email <a href="mailto:hello@lunara.app">hello@lunara.app</a>.
        </p>
      </Prose>
    </section>
  )
}
